import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useContext } from 'react';
import { BKJListItem } from '../../BKJListItem/index.js';
import { InfiniteScrollLoading } from '../../InfiniteScrollLoading/index.js';
import { useBKJComboBoxAsyncContext } from './BKJComboBoxAsync.context.js';
import { BKJComboBoxAsyncItem } from './BKJComboBoxAsyncItem.js';
export const BKJComboBoxAsyncOptionsMapper = ({ overrides = [] }) => {
    const { options, rowVirtualizer, context, name } = useBKJComboBoxAsyncContext();
    const { loadMore, status } = useContext(context);
    const hasGroupedOptions = options.some((opt) => opt.type === 'Group');
    switch (status) {
        case 'ERROR':
            return (_jsx(Fragment, { children: _jsx(BKJListItem, { variant: "SpaceBetween", label: "Error: Something went wrong", value: "ERROR", name: "ERROR", onChange: () => null, selected: [] }, "ERROR") }));
        case 'LOADING':
        case 'READY':
        default: {
            return (_jsxs(Fragment, { children: [_jsx("div", { style: {
                            height: rowVirtualizer.totalSize,
                        } }, "total-size"), rowVirtualizer.virtualItems.map((virtualRow) => {
                        const { id, label, disabled, value, style, type, subLabel = '', } = options[virtualRow.index];
                        const commonProps = {
                            id: id,
                            label: label,
                            disabled: !!disabled,
                            value: value,
                            index: virtualRow.index,
                            name: name,
                            subLabel,
                            style: {
                                ...style,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                transform: `translateY(${virtualRow.start}px)`,
                            },
                            key: id,
                            ref: virtualRow.measureRef,
                        };
                        switch (type) {
                            case 'Group':
                                return _jsx(BKJComboBoxAsyncItem, { ...commonProps, type: "Group" });
                            case 'Loader':
                                return (_jsx(InfiniteScrollLoading, { ...commonProps, onViewportEnter: loadMore, type: "Loader" }));
                            case 'NoResults': {
                                if (overrides.includes('NoInitialResults')) {
                                    if (status !== 'LOADING')
                                        return _jsx(BKJComboBoxAsyncItem, { ...commonProps, type: "NoResults" });
                                }
                                return _jsx(BKJComboBoxAsyncItem, { ...commonProps, type: "NoResults" });
                            }
                            case 'Standard':
                            default:
                                return (_jsx(BKJComboBoxAsyncItem, { ...commonProps, type: hasGroupedOptions ? 'Indented' : 'Standard' }));
                        }
                    })] }));
        }
    }
};
//# sourceMappingURL=BKJComboBoxAsyncOptionsMapper.js.map